import { Grid2, Stack, Typography, useTheme } from "@mui/material";
import { FoodsBadge, WhiteBox } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";
import { HistogramOverview } from "../../Overview/Strategy/HistogramOverview";
import { ActionPlanOverview } from "src/api/client-api/company/overview/useOrganizationOverview";
import { EmptyStrategy } from "../Strategy/EmptyStrategy";
import { useCompanyOverviewContext } from "src/context/Company/Overview/useCompanyOverviewContext";
import { NumericalScoreValue } from "src/api/client-api/olapScores/olapScoresSchema";

type Props = {
    actionPlan: ActionPlanOverview | null;
    currentValue: NumericalScoreValue;
    questionnaireName: string;
};
export const ActionPlan = (props: Props) => {
    const theme = useTheme();
    const { companyId, ssqId } = useCompanyOverviewContext();

    const { actionPlan, currentValue, questionnaireName } = props;

    return (
        <WhiteBox>
            <Stack padding={{ xs: theme.spacing(2), sm: theme.spacing(3) }} gap={theme.spacing(3)}>
                <ActionPlanHeader />
                {actionPlan === null ?
                    <EmptyStrategy companyId={companyId} ssqId={ssqId} questionnaireName={questionnaireName} />
                :   <Grid2 container spacing={theme.spacing(1)}>
                        <Grid2 size={{ xs: 12, md: 6 }}>
                            <HistogramOverview
                                ssqId={actionPlan.ssqId}
                                scoreId={actionPlan.score.id}
                                title={actionPlan.score.title}
                                currentValue={currentValue}
                                start={actionPlan.start}
                                end={actionPlan.end}
                                unit={actionPlan.unit}
                            />
                        </Grid2>
                    </Grid2>
                }
            </Stack>
        </WhiteBox>
    );
};

const ActionPlanHeader = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const datavizColors = theme.custom.dataviz.colorsWithExtra[12];

    return (
        <Stack flexDirection={"row"} gap={theme.spacing(2)} justifyContent={"space-between"} alignItems={"center"}>
            <Stack flexDirection="row" gap={theme.spacing(2)} alignItems={"center"}>
                <FoodsBadge
                    size={7}
                    icon={"trajectory"}
                    boxProps={{
                        sx: {
                            color: datavizColors.main,
                            backgroundColor: datavizColors.variant[100],
                            borderRadius: "8px",
                        },
                    }}
                />
                <Stack>
                    <Typography variant="h3">
                        {t("company.overview.strategy_title", "My trajectory and action plans")}
                    </Typography>
                </Stack>
            </Stack>
        </Stack>
    );
};
